module.exports = __webpack_public_path__ + "img/2.e8e29968.jpg";